<template>
    <div class="account">
        <div class="content">
            <div class="title">
                <div class="titleLogo">
                    <!-- <img src="http://weddingimg-oss.tvunetworks.cn/weddinglive-image/20190730/e6d9007f436b44479c5c48f23820b9e7.png" alt=""> -->
                    <img class="logo-img" src="../../assets/img/emblem-green.png" alt="">
                    <span>TVU Networks</span>
                </div>
            </div>
            <div class="creat" v-if="show.creat">
                <creat-account v-show="show.creatModule" @showModule="showModule"></creat-account>
            </div>
            <div class="activate" v-if="show.activate">
                <activate-account v-show="show.activateModule" @showModule="showModule" :backBtn="back.activate"></activate-account>
            </div>
            <div class="complete" v-if="show.complete">
                <complete-account v-show="show.completeModule" @showModule="showModule" :backBtn="back.complete"></complete-account>
            </div>
            <div class="failed" v-if="show.failed">
                <failed-account v-show="show.failedModule" @showModule="showModule" :backBtn="back.failed"></failed-account>
            </div>
            <div class="error" v-if="show.error">
                <error-account v-show="show.errorModule" @showModule="showModule"></error-account>
            </div>
            <div class="activateFailed" v-if="show.activateFailed">
                <activate-failed-account v-show="show.activateFailedModule" @showModule="showModule"></activate-failed-account>
            </div>
            <div class="regist" v-if="show.regist">
                <regist-account v-show="show.registModule" @showModule="showModule"></regist-account>
            </div>
        </div>
    </div>
</template>
<script>
import CreatAccount from './creat';
import ActivateAccount from './activate';
import completeAccount from './complete';
import failedAccount from './failed';
import errorAccount from './error';
import activateFailedAccount from './activateFailed';
import registAccount from './regist';
export default {
    data(){
        return{
            show:{
                creat:false,
                creatModule:false,
                activate:false,
                activateModule:false,
                complete:false,
                completeModule:false,
                failed:false,
                failedModule:false,
                error:false,
                errorModule:false,
                activateFailed:false,
                activateFailedModule:false,
                regist:false,
                registModule:false,
            },
            backList:[],
            back:{
                activate:true,
                complete:true,
                failed:true,
            },
        }
    },
    components:{
        CreatAccount,
        ActivateAccount,
        completeAccount,
        failedAccount,
        errorAccount,
        activateFailedAccount,
        registAccount
    },
    created(){
        this.query = {};
        try {
            //这里出错了说明url上没有任何参数，也就是默认 creat
            let pathParams = decodeURIComponent(window.location.href).split('?')[1].split('&');
            pathParams.map(v=>{
                let vArray = v.split('=');
                this.query[vArray[0]] = vArray[1]
            })
        } catch (error) {
            this.query = {type: 'creat'};
        }
        let { type, email, userId, firstName, msg } = this.query;
        if(type){
            this.show[type] = true;
            this.show[type+'Module'] = true;
            this.back[type] = false;
        }
        if(email) this.$store.state.email = email;
        if(userId) this.$store.state.userId = userId;
        if(firstName) this.$store.state.firstName = firstName;
        if(msg) this.$store.state.msg = msg;
        
        if(this.show.completeModule){
            this.$store.state.showShare = false;
        }else{
            this.$store.state.showShare = true;
        }
    },
    methods:{
        showModule(obj){
            Object.keys(this.show).map(v=>{
                if(v.indexOf('Module') != -1){
                    this.show[v] = false;
                }
            })
            if(obj.type == 'next'){
                this.show[obj.module] = true;
                this.show[obj.module+'Module'] = true;
                obj.back && this.backList.unshift(obj.back);
                // this.$router.push({name:'account',query:{type:obj.module}})
            }else{
                this.show[this.backList[0]+'Module'] = true;
                this.backList.length && this.backList.splice(0,1);
                // this.$router.push({name:'account',query:{type:this.backList[0]}})
            }
            if(this.show.completeModule){
                this.$store.state.showShare = false;
            }else{
                this.$store.state.showShare = true;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.account{
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 1;
    .content{
        margin: 0 auto;
        color: #333;
        background: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        border-radius: .1rem;
        z-index: 1;
        .title{
            font-size: 0.2rem;
            position: relative;
            margin-bottom: 0.24rem;
            .titleLogo{
                width: 60%;
                display: inline-block;
                span{
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    margin-left: 0.12rem;
                }
                img {
                    height: 1rem;
                    width: 1rem;
                }
            }
            .downLogo{
                width: 40%;
                display: inline-block;
                text-align: right;
                margin-top: 0.05rem;
                a{
                    display: inline-block;
                    height: 0.4rem;
                    img{
                        height: 0.4rem;
                        width:1.2rem;
                    }
                }
            }
        }
        /deep/.el-form-item{
            margin-bottom: .26rem;
        }
        /deep/.el-button{
            width: .88rem;
            padding: .12rem 0;
            background: #1EC345;
            color: #fff;
        }
    }
}
@media(max-width:1024px){
    .account{
        .content{
            .title{
                margin-bottom: 0.2rem;
                .titleLogo{
                    span{
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        margin-left: 0.12rem;
                    }
                    img{
                        width: .32rem;
                        height: .32rem;
                    }
                }
                .downLogo{
                    a{
                        display: inline-block;
                        height: 0.32rem;
                        img{
                            height: 0.32rem;
                            width:0.96rem;
                        }
                    }
                }
            }
        }
    }
}
@media(max-width:760px){
    .account{
        .content{
            .title{
                font-size: 0.18rem;
                .titleLogo{
                    span{
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        margin-left: 0.12rem;
                    }
                    img{
                        width: .28rem;
                        height: .28rem;
                    }
                }
                .downLogo{
                    a{
                        display: inline-block;
                        height: 0.28rem;
                        img{
                            height: 0.28rem;
                            width:0.84rem;
                        }
                    }
                }
            }
        }
    }
}
@media(max-width:620px){
    .account{
        .content{
            .title{
                // font-size: 0.16rem;
                .titleLogo{
                    span{
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        margin-left: 0.12rem;
                    }
                    img{
                        width: .25rem;
                        height: .25rem;
                    }
                }
                .downLogo{
                    a{
                        display: inline-block;
                        height: 0.25rem;
                        img{
                            height: 0.25rem;
                            width:0.75rem;
                        }
                    }
                }
            }
        }
    }
}
@media(max-width:350px){
    .account{
        .content{
            .title{
                // font-size: 0.14rem;
                .titleLogo{
                    // img{
                    //     // width: .22rem;
                    //     // height: .22rem;
                    // }
                    .logo-img {
                        width: .22rem;
                        height: .22rem;
                    }
                }
                .downLogo{
                    a{
                        height: 0.22rem;
                        img{
                            height: 0.22rem;
                            width:0.66rem;
                        }
                    }
                }
            }
        }
    }
}
</style>